import { ComponentMirror, Injectable, reflectComponentType } from '@angular/core'
import { ComponentType } from '@angular/cdk/overlay'

@Injectable({ providedIn: 'root' })
export class ElementLoaderService {
  getComponentSelector(component: ComponentType<any>): string {
    const metadata: ComponentMirror<any> = reflectComponentType(component)
    return metadata.selector
  }
}
